// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/age/official.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'age.official',
	post: false,
	require: function(config, filter) { return sorted('age.official', filter) > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_age_official', '>', 0)
		query.order('g.game_age_official', sortReverse('age.official', filter), sortPriority('age.official', filter))
	}
}
